import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from 'controller/redux/actions/authActions';
import { PAGES, USER_TYPES, PATHS } from 'controller/constants';
import { useLocation } from "react-router-dom";
import ChangePasswordModal from '../modals/ChangePasswordModal';
const HIDE_MENU_THRESHOLD = 1650;

const HeaderComponent = ({ toggleContentVisibility, showContent, setShowContent }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isLoggedin = useSelector((state) => state.auth.isLoggedin);
    const user = useSelector((state) => state.auth.user);
    const userType = user ? user.user.role : USER_TYPES.GUEST;
    const location = useLocation();

    const forceToggleMenu = () => {
        setShowContent((prev) => !prev); // This ignores the width constraint from App.js
    };

    const notificationsData = useSelector((state) => {
        const data = state.data['notifications']?.data;
        return data || null; // Return `null` instead of creating a new array reference
    });

    const filteredPages = userType ? PAGES[userType] : [];

    const handleLogout = () => {
        dispatch(logout());
    };

    useEffect(() => {
        console.log('HeaderComponent mounted');
    }, []);

    useEffect(() => {
        console.log('HeaderComponent useEffect triggered', { isLoggedin, userType, location });
        if (!isLoggedin || userType === USER_TYPES.GUEST) {
            navigate(PATHS.LOGIN);
        }
    }, [isLoggedin, userType, navigate, location]);

    const [isPasswordModalVisible, setIsPasswordModalVisible] = useState(false);

    const passwordChange = () => {
        setIsPasswordModalVisible(true);
    };

    return (
        <header id="main-header" location={location.pathname}>
            <div>
                {user && (
                    <div id="main-header--user-bar">
                        <div>
                            <div>
                                <i>notifications</i>
                                {notificationsData?.data?.meta?.count > 0 && (
                                    <span className="notification-bubble">{notificationsData.data.meta.count}</span>
                                )}
                            </div>
                            <button onClick={passwordChange} ><i>lock</i></button>
                        </div>
                        {/* <span>{user.partner.name} ({user.user.email})</span> */}
                        <span>{user.partner.name}</span>
                        <div>
                            <button onClick={handleLogout}><i>logout</i></button>
                        </div>
                        {/* <p>DEBUG:{user.user.role} || {user.partner.type}</p> */}
                    </div>
                )}
                <h3 id="main-header--title">Sistema Integrado de Reporting de Música Ambiente</h3>
                <nav>
                    {filteredPages.map((menu, index) => (
                        <div key={index}>
                            {location.pathname === menu.path ? (
                                <div className="nav-item current" path={menu.path} onClick={toggleContentVisibility}>
                                    <i></i><span>{menu.label}</span>
                                </div>
                            ) : (
                                <Link to={menu.path} className="nav-item" path={menu.path} onClick={toggleContentVisibility}>
                                    <i></i><span>{menu.label}</span>
                                </Link>
                            )}
                        </div>
                    ))}
                </nav>
                <footer>
                    <span>
                        Copyright @ {new Date().getFullYear()}.
                        <br />
                        Todos os direitos reservados.
                    </span>
                </footer>
                <button id="main-header--toggle-menu" className="btn-square btn-fill" onClick={forceToggleMenu} >
                    <i>{showContent ? 'arrow_back_ios' : 'menu'}</i>
                </button>
            </div>
            <ChangePasswordModal
                visible={isPasswordModalVisible}
                onHide={() => setIsPasswordModalVisible(false)}
            />
        </header>
    );
};

export default HeaderComponent;
